<mat-form-field appearance="fill" class="w-full">
  <mat-label>Gads</mat-label>

  <mat-date-range-input [rangePicker]="yearPicker">
    <input matStartDate placeholder="Sākuma datums" readonly [value]="selectedStartDate" />
    <input matEndDate placeholder="Beigu datums" readonly [value]="selectedEndDate" />
  </mat-date-range-input>

  <mat-datepicker-toggle matSuffix [for]="yearPicker" />
  <mat-datepicker-toggle matSuffix aria-label="Notīrīt filtru" (click)="clearDate()">
    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
  </mat-datepicker-toggle>

  <mat-date-range-picker
    #yearPicker
    color="primary"
    panelClass="year-datepicker"
    startView="multi-year"
    (yearSelected)="onYearSelected($event, yearPicker)"
  />
</mat-form-field>
